import React, {useState, useEffect} from 'react'
import Api from '../servicios/api'
import {Header, Titulo, ContenedorHeader} from '../elementos/Header'
import {ContenedorBotonesLista, BotonEliminar, BotonCheck, Buscador, ContenedorBuscador, InputBuscador} from '../elementos/ElementosDeLista'
import {ReactComponent as IconoBorrar} from '../imagenes/borrar.svg'
import Alerta from '../elementos/Alerta'
import Cargando from '../elementos/Cargando'
import VentanaModalText from '../elementos/VentanaModalText';
import { FaCheck, FaSearch } from "react-icons/fa";


const ListarGestionVisitas = () => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [gestionVisitas, setGestionVisitas] = useState([]);
    const [alerta, setAlerta] = useState({});
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [modalText, setModalText] = useState({});
    const [estadoModalText, setEstadoModalText] = useState(false);
    const [idGestion, setidGestion] = useState();
    const [parametroActualizar, setParametroActualizar] = useState();
    const [textAreaMotivo, setTextAreaMotivo] = useState("");
    const [buscador, setBuscador] = useState();

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        cargarDatos();
    }, [buscador]);

    //Este hook se ejecuta solamente al primer renderizado
    const cargarDatos = () => {
        var datosEnviar;

        if(buscador){
            datosEnviar = {busqueda: buscador}
        }

        fetch(Api+"?consultarGestionVisita",{
            method:"POST",
            body:JSON.stringify(datosEnviar)
        })
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true)
            setGestionVisitas(datosRespuesta)
        })
        .catch(console.log)
    }

    const handleChange = (e) => {
        switch(e.target.name){
            case 'textAreaMotivo':
                setTextAreaMotivo(e.target.value);
                break;
            case 'buscador':
                setBuscador(e.target.value);
                break;
            default:
                break;
        }
    }

    const handleModalText = (id, parametro) => {
        if(parametro === 0){
            setidGestion(id)
            setParametroActualizar(parametro)
            setEstadoModalText(true)
            setModalText({
                header: 'No Asistió',
                body: 'Motivo'
            });
        }
        else{
            setidGestion(id);
            setParametroActualizar(parametro)
            setEstadoModalText(true);
            setModalText({
                header: 'Asistió',
                body: 'Opinión'
            });
        }
    }

    const marcarAsistencia = () => {
        setEstadoModalText(false);
        setEstadoAlerta(false);
        setAlerta({});

        var datosEnviar = {id:idGestion, param:parametroActualizar, opinion:textAreaMotivo}
        fetch(Api+"?actualizarGestionVisita=1",{
            method:"POST",
            body:JSON.stringify(datosEnviar)
        })
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            if(datosRespuesta.success === 0){
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'error',
                    mensaje: datosRespuesta.mensaje
                });
            }
            else{
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'exito',
                    mensaje: datosRespuesta.mensaje
                });
            }
            cargarDatos();
        })
        .catch(console.log)
    }

    if(!datosCargados){
        return(
            <Cargando />
        );
    }

    else{
        return (
            <>
                <Header>
                    <ContenedorHeader>
                        <Titulo>Gestión de Visitas</Titulo>
                    </ContenedorHeader>
                </Header>

                <Buscador>
                    <ContenedorBuscador>
                        <InputBuscador
                            type="text"
                            name="buscador"
                            placeholder="Ingrese nombre de Institución / Facultad"
                            value={buscador}
                            onChange={handleChange}
                        />
                        <i className='icono-buscador'><FaSearch /></i> 
                    </ContenedorBuscador>
                </Buscador>

                <div className="contenedor-tabla">
                    <div className="card card-tamano card-tamano-busqueda">
                        <div className="card-body">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Fecha Visita</th>
                                        <th>Hora Visita</th>
                                        <th>Nombre de Institución o Facultad</th>
                                        <th># de Visitantes</th>
                                        <th>Correo</th>
                                        <th>Teléfono</th>
                                        <th>Estado</th>
                                        <th>Asistencia</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        gestionVisitas.success !== 0 &&
                                            gestionVisitas.map(
                                                (gestion)=>(
                                                    <tr key={gestion.GV_ID}>
                                                        <td>{gestion.SV_Fecha}</td>
                                                        <td>{gestion.SV_Hora}</td>
                                                        <td>{gestion.SV_Institucion}</td>
                                                        <td>{gestion.SV_NumVisitantes}</td>
                                                        <td>{gestion.SV_Correo}</td>
                                                        <td>{gestion.SV_Telefono}</td>
                                                        {gestion.GV_Estado === '0' &&
                                                        <td>Pendiente</td>
                                                        }
                                                        
                                                        <td>
                                                            <ContenedorBotonesLista>
                                                                <BotonCheck title="Asístió" onClick={()=> handleModalText(gestion.GV_ID, 1)}>
                                                                    <FaCheck />
                                                                </BotonCheck>
                                                                
                                                                <BotonEliminar title="No Asístió" onClick={()=> handleModalText(gestion.GV_ID, 0)}>
                                                                    <IconoBorrar />
                                                                </BotonEliminar>
                                                            </ContenedorBotonesLista>
                                                        </td>
                                                    </tr>
                                                )
                                            )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <Alerta 
                        tipo={alerta.tipo}
                        mensaje={alerta.mensaje}
                        estadoAlerta={estadoAlerta}
                        setEstadoAlerta={setEstadoAlerta}
                />

                <VentanaModalText
                        textAreaMotivo={textAreaMotivo}
                        handleChange={handleChange}
                        mensajeHeader={modalText.header}
                        mensajeBody={modalText.body}
                        estadoModalText={estadoModalText}
                        setEstadoModalText={setEstadoModalText}
                        handleConfirm={marcarAsistencia}
                />  
                    
            </>
        );
    }
}
 
export default ListarGestionVisitas;